import {
  CalloutLogWorkScreen,
  type CalloutLogWorkScreenProps,
} from '@/screens/CalloutLogWorkScreen'

export type SessionLogWorkScreenProps = CalloutLogWorkScreenProps

export function SessionLogWorkScreen(props: SessionLogWorkScreenProps) {
  return (
    <CalloutLogWorkScreen
      {...props}
      resourceLabel={props.resourceLabel ?? 'TeamViewer Session'}
      invoiceRoute="session"
    />
  )
}
